import { CreatorPayload } from "./types";

export const fetchCreatorCollectionFromUrl = async (url: string): Promise<CreatorPayload> => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to load creator data (${response.status} ${response.statusText})`);
  }
  return (await response.json()) as CreatorPayload;
};

export const loadCreatorCollection = (source: string): Promise<CreatorPayload> => {
  return fetchCreatorCollectionFromUrl(source);
};
